<template>
  <div class="layer">
    <button type="button" class="btnClose" @click="cancel"></button>
    <div class="inner">
      <h2 class="layerTitle">파일 불러오기</h2>
      <div class="mb15">다른 사이트의 파일을 불러올 수 있습니다.<br>사이트명과 파일명을 필수로 입력해야 하며, 해당 파일의 특정 버전을 불러올 수도 있습니다.</div>
      <div class="innerItem">
        <p class="innerTitle setLabel"><span class="colorRed">*</span> site id</p>
        <input type="text" class="input" v-model="site" placeholder="aa7">
      </div>
      <div class="innerItem">
        <p class="innerTitle setLabel"><span class="colorRed">*</span> file id</p>
        <input type="text" class="input" v-model="id" @keypress.enter="load" placeholder="aa7.abcdef00-0000-0000-0000-000000000000">
      </div>
      <div class="innerItem">
        <p class="innerTitle setLabel">version</p>
        <input type="text" class="input" v-model="version" @keypress.enter="load" placeholder="10">
      </div>
      <div class="btns">
        <button type="button" class="btn btnWhite" @click="cancel">{{ locale.cancel }}</button>
        <button type="button" class="btn btnPrimary ml15" @click="load">{{ locale.load }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'

export default {
  name: 'ImportVersionFile',
  props: [
    'locale'
  ],
  data () {
    return {
      site: null,
      id: null,
      version: null
    }
  },
  methods: {
    load () {
      const inputId = regExp.replaceAllEmpty(this.id)
      const site = regExp.replaceAllEmpty(this.site)
      const version = parseInt(this.version)
      const uuid = inputId.split('.')[1]
      const isValidSite = regExp.replaceAllEmpty(site)
      const isValidUuid = UNIQUE.isUuid(uuid)
      const isValidId = isValidUuid && `${inputId.split('.')[0]}.${uuid}`
      const id = isValidId
      if (!isValidSite) {
        alert('사이트명을 정확하게 입력하세요')
      } else if (!isValidId) {
        alert('불러오려는 페이지id를 정확하게 입력하세요')
      } else {
        if (window.confirm('이 페이지를 불러오시겠습니까?')) {
          this.$emit('load', {
            site: site,
            id: id,
            ...version && {
              version: version
            }
          })
        }
      }
    },
    cancel () {
      if (window.confirm(this.locale.confirm_cancel)) {
        this.close()
      }
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.layer .inner {
  max-width: 480px;
}
.isRequired > .label:before {
    content: "*";
    margin-right: 0.3em;
    color: $color-red;
	}
.btns {
  margin: 30px auto 0;
  text-align: center;
}
</style>
